import React from 'react';
import {useConnect} from '@lore/query-connect';
import {PayloadStates} from '@lore/utils';
import PropTypes from "prop-types";
import Loader from '@/components/Loader';
import useDialogConfig from '@hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import {EventShareDialog} from '@/features/share-event';

Launcher.propTypes = {
  onClose: PropTypes.func.isRequired
};
export default function Launcher(props) {
  const config = useDialogConfig();

  const event = useConnect('event.byId', {
    id: config.params.eventId
  });

  if (event.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <EventShareDialog
      event={event}
      onClose={props.onClose}
      fromManage={config.params.source === 'manage'}
    />
  );
};
